import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { faUser, faUserGraduate } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ActionButton } from 'components'
import { ContextMenu } from 'devextreme-react/context-menu'
import { Item } from 'devextreme/ui/context_menu'
import React, { FC, Fragment } from 'react'
import { useSettingService } from 'services'
import './user-menu.scss'

export type MenuItem = {
    text: string,
    icon: IconProp,
    onItemClick: () => void,
}

type Props = {
    menuItems: MenuItem[],
    buttonColor: string;
}

export const UserMenu: FC<Props> = ({ menuItems = [], buttonColor }) => {

    // menuItems = [];

    const [isMenuVisible, setIsMenuVisible] = React.useState<boolean>(false)
    const { getTrainingMode } = useSettingService()
    const isTrainingMode: boolean = getTrainingMode()

    const renderMenuItem = (e: MenuItem) => {
        const isLastItem: boolean = e.text === menuItems[menuItems.length - 1].text

        return (
            <div className={`user-menu-item${isLastItem ? '-last' : ''}`}>
                <FontAwesomeIcon icon={e.icon} size={'lg'} color={'#444444'}/>
                <div>{e.text}</div>
            </div>
        )
    }

    const handleMenuOptionChanged = (e: any) => {
        if(e.fullName === 'visible') {
            setIsMenuVisible(e.value)
        }
    }

    const handleItemClick = (e: any) => { 
        setIsMenuVisible(false)
        const clickHandler = e.itemData.onItemClick
        clickHandler && clickHandler()
    }
    
    return (
        <Fragment>
            <ActionButton
                id={'user-button'}
                icon={isTrainingMode ? faUserGraduate : faUser}
                buttonWidth={'30px'}
                buttonColor={buttonColor}
                iconColor={'white'}
                iconSize={'lg'}
                onClick={() => setIsMenuVisible(true)}
            />
            {menuItems &&
                <ContextMenu
                    visible={isMenuVisible}
                    target={'#user-button'}
                    dataSource={menuItems as Item[]}
                    itemRender={renderMenuItem}
                    width={Math.min(window.innerWidth / 1.5, 300)}
                    onOptionChanged={handleMenuOptionChanged}
                    onItemClick={handleItemClick}
                />
            }
        </Fragment>
    )
}